import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import { fetchDeliveries } from '../services/deliveries.service'

export { type DeliveryRow } from '../services/deliveries.service'

export function injectDeliveriesQuery() {
  const cartoClient = injectCartoClient()

  return injectQuery(() => ({
    queryKey: ['deliveries'],
    queryFn: async ({ signal }) => {
      return fetchDeliveries(cartoClient, signal)
    },
    select: (rows) => {
      return [...rows].sort((a, b) => b.start.localeCompare(a.start))
    },
  }))
}
